// import styled from 'styled-components'

import { Button, DefaultButton } from '../../styles/defaults'

export const StyledButton = Button.extend`
  background: ${props => props.background};
  color: ${props => props.color};
  border: 1px solid ${props => props.border};
  border-radius: ${props => (props.radius === 'true' ? '0.25rem' : 'none')};

  &:hover {
    background: ${props => props.hover};
    color: ${props => (props.hoverColor ? props.hoverColor : props.color)};
  }
`

export const SimpleButton = DefaultButton.extend`
  background: ${props => props.background};
  color: ${props => props.color};
  border: 1px solid ${props => props.border};
  border-radius: ${props => (props.radius === 'true' ? '0.25rem' : 'none')};

  &:hover {
    background: ${props => props.hover};
    color: ${props => (props.hoverColor ? props.hoverColor : props.color)};
  }
`



// WEBPACK FOOTER //
// ./src/components/Button/styles.js